// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + ({"678":"component---src-pages-index-js","774":"framework","883":"component---src-pages-404-js"}[chunkId] || chunkId) + "-" + {"231":"638a5da9237edbedba40","678":"bdef04e3b339a5cfcb49","680":"5f65fee675f3058f8db9","774":"fdd8f06036075456ab24","883":"2ce1221059c4b08a358f"}[chunkId] + ".js";
};